export const FETCH_EDITION_ARTICLES_TYPE = 'EDITION_ARTICLES';

export const fetchEditionArticlesActionCreator = (sliceId, promise) => ({
  meta: {
    sliceId,
  },
  type: FETCH_EDITION_ARTICLES_TYPE,
  payload: promise,
});
